import { Component, Input, OnInit, inject } from "@angular/core";
import { IconService } from "../../core/icon.service";

@Component({
  selector: "app-icon",
  templateUrl: "./icon.component.html",
  styleUrls: ["./icon.component.scss"],
  standalone: false,
})
export class IconComponent implements OnInit {
  private iconService = inject(IconService);

  @Input() icon: string;
  @Input() isSelected = false;
  @Input() size = 16;
  @Input() iconStyle: string;
  isSvg = false;

  ngOnInit(): void {
    this.isSvg = this.iconService.svgIcons.has(this.icon);
  }
}
